<template lang="pug">
  span(v-bind:class="colorClass")
    template(v-if="isZero") ±0
    template(v-else) {{asSecond}}
</template>

<script>
export default {
  props: {
    expectMinus: {
      type: Boolean,
      default: false,
    },
    digits: {
      type: Number,
      default: 1,
    },
    value: Number,
  },
  computed: {
    isZero: function() {
      return this.value == 0;
    },
    colorClass: function() {
      if (this.expectMinus) {
        return this.value > 0 ? 'text-danger'
          : this.value < 0 ? 'text-primary'
          : 'text-warning';
      } else {
        return 'text-primary';
      }
    },
    asSecond: function() {
      const factor = Math.pow(10, this.digits);
      const sec = Math.round(this.value * factor) / factor;
      return `${sec}秒`;
    },
  },
}
</script>
